import { useTranslation } from 'react-i18next';
import 'twin.macro';

const CameraProblemSection = ({ text, showRefreshHint = true, icon, iconAlt }) => {
  const { t } = useTranslation('camera-permission');

  // absolute inset-0 (not w-full h-full): this box lives inside a `flex`
  // preview container alongside the camera <video> element and the status
  // icons — the icons already overlay via absolute positioning, but this box
  // used to be a plain flex sibling, so on any render where the <video> is
  // still mounted (e.g. mid permission-state transition) the two split the
  // row's width between them instead of this one filling it, leaving half
  // the preview showing the container's own background through the gap.
  //
  // Mobile only (Figma "Camera permission - Disabled"): the text sits in a
  // flex-1 block that centers itself in whatever space is left, and the icon
  // follows it in normal flow. That's what keeps the icon from sitting on
  // top of the text on short screens — the old markup centered the text
  // across the full box height while a sibling <img> was absolutely pinned
  // near the bottom, so the two overlapped whenever the centered text grew
  // tall enough to reach that far down. md and above render the untouched
  // original markup (hidden md:flex below).
  return (
    <>
      <div tw="md:hidden absolute inset-0 flex flex-col items-center justify-end gap-3 bg-black text-white text-center p-5">
        <div tw="flex-1 min-h-0 w-full flex flex-col items-center justify-center gap-2">
          <p tw="text-[32px] font-bold">{text}</p>
          {showRefreshHint && <p tw="text-[16px] font-medium">{t('problemSection.refreshHint')}</p>}
        </div>
        <img
          loading="lazy"
          decoding="async"
          src={icon}
          alt={iconAlt}
          tw="w-[48px] h-auto shrink-0"
        />
      </div>
      <div tw="hidden md:flex absolute inset-0 flex-col text-[24px] lg:text-[48px] text-white items-center justify-center text-center bg-black p-5 lg:p-0">
        {text}
      </div>
    </>
  );
};

export default CameraProblemSection;
